import { FILE_UPLOAD_STATUS } from "../constants/common";
import { OperatorType, TableDesc } from "./campaign";
import { DESTINATION_TYPES, SUB_TYPES } from "./unifiedMapping";

export interface Person {
  company_name: string | null;
  email: string;
  first_name: string | null;
  id: string;
  last_name: string | null;
  person_created_time: string;
  phone_number: string | null;
  title: string | null;
}
export interface PersonComplete extends Person {
  name: string;
  unsubscribed: number;
  _created_time: string;
  _modified_time: string;
  _deleted_time: string | null;
}

export enum COLUMN_VALUE_TYPES {
  STRING = "string",
  NUMBER = "number",
  DATE = "date",
  DATETIME = "datetime",
  BOOL = "bool",
}

export interface PersonDetailsField extends TableDesc {
  column_tag?: string;
  value?: any;
}

export interface PersonEvent {
  event_name: string;
  event_date: string;
  event_properties: string;
  user_id: string;
  org_id: string;
}

export interface PersonMarketingDetails {
  timestamp: string;
  campaign_id: string;
  campaign_name: string;
  template_id: string;
  template_name: string;
  event: string;
  context: string | null;
  correlation_id: string;
}

export interface PersonType {
  [key: string]: PersonDetailsField;
}

export interface PersonColumns {
  [columnName: string]: PersonDetailsField;
}

export type PersonLookup = {
  id: string;
  email: string;
  product_user_id?: string;
  org_id?: string;
};

export enum PERSON_ORG_MAPPING {
  ONE_TO_NONE = "one_to_none",
  ONE_TO_ONE = "one_to_one",
  MANY_TO_MANY = "many_to_many",
}

export type ProductPersonDetails = {
  person_id: string;
  org_id: string;
  product_user_id: string;
  email: string;
  user_properties: { [column: string]: string } | null;
};

export type PersonUpdateFields = {
  email: string;
  default_fields: { [key: string]: string };
  custom_fields: { [key: string]: string };
};

export interface UnsubUrl {
  url: string | null;
  updated_at: string;
  created_at: string;
}

export interface MarketingActivity {
  id: string;
  display: string;
  arguments: MarketingActivityArgument[];
}

export interface MarketingActivityArgument {
  id: string;
  display: string;
  type: OperatorType;
}
export enum MAPPING_FIELD {
  PERSON_MAPPING = "person_mapping",
  PRODUCT_USER_MAPPING = "product_user_mapping",
  ACCOUNT_MAPPING = "account_mapping",
}
export interface PersonDestination {
  name: string;
  type: DESTINATION_TYPES;
  display: string;
  custom: boolean;
  required: boolean;
  length: number | null;
  hidden: boolean;
  sub_type?: SUB_TYPES | null;
  primary_key?: boolean;
  read_only?: boolean;
  updatable?: boolean;
  value?: any;
}

export interface MappingDestination {
  mapping_field: MAPPING_FIELD;
  columns: PersonDestination[];
}

export interface PersonDestinationFields {
  [key: string]: PersonDestination;
}

export interface Matches {
  total_contacts: number;
  new_contacts: number;
  duplicate_contacts: number;
  error_contacts: number;
  total_entries_to_be_created: number;
  total_entries_to_be_updated: number;
  report: string;
}

export interface ImportReq {
  filepath: string;
  enable_update: boolean;
  overwrite_values: boolean;
  ignore_blank: boolean;
}

export interface ImportResults {
  success: boolean;
  new_records: number;
  records_updated: number;
}
export interface ProductPersonType {
  key: string;
  details: PersonDestination;
  onDataClick?: (organisationId: string) => void;
  isHyperLink?: boolean;
  redirectPage?: () => void;
}

export interface UploadStatus {
  filepath: string;
  status: FILE_UPLOAD_STATUS;
  error?: string;
}

export const MAP_TO_DESTINATION_TYPE: { [key: string]: DESTINATION_TYPES } = {
  bool: DESTINATION_TYPES.BOOLEAN,
  string: DESTINATION_TYPES.STRING,
  number: DESTINATION_TYPES.INTEGER,
  datetime: DESTINATION_TYPES.DATETIME,
  json: DESTINATION_TYPES.JSON,
};
